import { IConfig } from '../interfaces/config.interface';

export const devConfig: IConfig = {
  apiUrl: 'http://localhost:8000',
};

export default devConfig;
